export default function _isObject(x) {
  return Object.prototype.toString.call(x) === '[object Object]';
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_ramda@0.25.0@ramda/es/internal/_isObject.js
// module id = 255
// module chunks = 362